<template>
  <div>
    <p class="font-small-2 text-muted mb-0">
      {{ header }}
    </p>
    <p :class="`font-weight-bolder ${!content || content === '' ? 'text-muted' : ''}`">
      {{ content || '[NO CAPTURADO]' }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
}
</script>
